export const defaultClosedBookPolicy = {
  requireFullscreen: true,
  detectFullscreenExit: true,

  detectTabSwitch: true,
  detectWindowBlur: true,
  detectVisibilityChange: true,

  blockContextMenu: true,
  blockCopy: true,
  blockPaste: true,
  blockCut: true,
  blockTextSelection: false,
  blockPrint: true,

  blockKeyboardShortcuts: true,

  blockNavigationAway: true,
  blockExternalLinks: true,
  allowedDomains: [],

  requireScreenShare: true,
  detectScreenShareTermination: true,
  reconnectScreenShareAllowed: true,

  logSecurityEvents: true,
  pauseTimerOnSecurityInterruption: false,

  thresholds: {
    blurGracePeriodMs: 1500,
    fullscreenGracePeriodMs: 1000,
    maxFullscreenExits: 3,
    maxFocusLossEvents: 5
  }
};

function isPlainObject(value) {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

export function mergePolicy(overrides) {
  const src = isPlainObject(overrides) ? overrides : {};
  const thresholds = {
    ...defaultClosedBookPolicy.thresholds,
    ...(isPlainObject(src.thresholds) ? src.thresholds : {})
  };
  return {
    ...defaultClosedBookPolicy,
    ...src,
    thresholds,
    allowedDomains: Array.isArray(src.allowedDomains)
      ? src.allowedDomains.map((d) => String(d).toLowerCase())
      : defaultClosedBookPolicy.allowedDomains
  };
}

export function envClosedBookOverride() {
  if (typeof process !== 'undefined' && process.env) {
    const raw =
      process.env.REACT_APP_CLOSED_BOOK_SECURITY ??
      process.env.CLOSED_BOOK_SECURITY_ENABLED;
    if (raw == null || raw === '') return null;
    const v = String(raw).toLowerCase();
    if (v === 'false' || v === '0' || v === 'off') return false;
    if (v === 'true' || v === '1' || v === 'on') return true;
  }
  return null;
}

/**
 * Layer is on only when env allows, the exam toggle is on, and
 * (if a tenant is known) the platform feature flag is on.
 * Legacy library_id exams with tenant_id=0 use exam toggle + env only.
 */
export function isClosedBookEnabled({
  examEnabled = false,
  featureFlagEnabled = false,
  hasTenant = false,
  envOverride = envClosedBookOverride()
} = {}) {
  if (envOverride === false) return false;
  if (!examEnabled) return false;
  if (hasTenant && !featureFlagEnabled) return false;
  return true;
}

export function isAllowCopyTarget(target) {
  if (!target || typeof target.closest !== 'function') return false;
  return Boolean(target.closest('[data-allow-copy="true"]'));
}
